/**
 * Утилиты для обработки ошибок API
 */

/**
 * Извлекает читаемое сообщение об ошибке из объекта ошибки
 */
export const handleApiError = (error: any): string => {
  // Проверяем ответ от сервера
  if (error?.response?.data?.error) {
    return error.response.data.error;
  }

  if (error?.response?.data?.message) {
    return error.response.data.message;
  }

  // Проверяем сообщение из axios
  if (error?.message) {
    return error.message;
  }

  // Fallback
  return 'Неизвестная ошибка';
};

/**
 * Скачивает blob как файл
 */
export const downloadFile = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
